/**
 * Complete Finnish plate (`ABC-123`, `AB-1`, `123-ABC`), or null.
 *
 * Same contract as `formatFinnishPlate` in
 * `packages/shared/src/identifiers/vehicle-identifiers.ts` (#4122). The portal
 * does not import the shared package root — that barrel pulls Node-only
 * modules — and ESLint forbids a relative `packages/` import. The hook test
 * (useVehicleLookup.test.ts) loads that source and requires this copy to match it.
 */
const PLATE_LETTER = 'A-ZÅÄÖ';
const PLATE_COMPARE_KEEP = new RegExp(`[^${PLATE_LETTER}0-9]`, 'gu');
const FINNISH_PLATE_LETTERS_FIRST = new RegExp(`^([${PLATE_LETTER}]{2,3})(\\d{1,3})$`, 'u');
const FINNISH_PLATE_DIGITS_FIRST = new RegExp(`^(\\d{1,3})([${PLATE_LETTER}]{2,3})$`, 'u');

export function formatFinnishPlate(input: string): string | null {
  const key = input.toUpperCase().replace(PLATE_COMPARE_KEEP, '');
  FINNISH_PLATE_LETTERS_FIRST.lastIndex = 0;
  FINNISH_PLATE_DIGITS_FIRST.lastIndex = 0;
  const lettersFirst = FINNISH_PLATE_LETTERS_FIRST.exec(key);
  const letters = lettersFirst?.[1];
  const letterDigits = lettersFirst?.[2];
  if (letters !== undefined && letterDigits !== undefined) {
    return `${letters}-${letterDigits}`;
  }
  const digitsFirst = FINNISH_PLATE_DIGITS_FIRST.exec(key);
  const digitPart = digitsFirst?.[1];
  const trailingLetters = digitsFirst?.[2];
  if (digitPart !== undefined && trailingLetters !== undefined) {
    return `${digitPart}-${trailingLetters}`;
  }
  return null;
}
